<template>
  <v-container fluid class="title-back white--text title-text">
    <v-row no-gutters>
      <v-col sm="7" cols="12" class="text-center margin-top">
        <div class="font-weight-black text-sm-h6 text-md-h5">新型コロナ対策支援プロジェクト</div>
        <div class="text-lg-h4 text-md-h5 text-sm-body-1 font-weight-black">とやまエネルギーオークションサービス</div>
        <div class="font-weight-black text-sm-h6 text-md-h5">
          中小企業 、小規模事業者様の
        </div>
        <div class="font-weight-black text-sm-h6 text-md-h5">
          <span class="text-md-h4 text-sm-h5 font-weight-black text-decoration-underline">電気料金削減</span>
          支援サービス
        </div>
        <v-container :class="$vuetify.breakpoint.smAndUp ? 'margin-top' : ''">
          <v-row>
            <v-col>
              <v-btn
                color="warning"
                class="font-weight-black text-sm-h6"
                :x-large="$vuetify.breakpoint.smAndUp"
                href="https://form.run/@rrr-eneoku/"
              >
                問い合わせ・資料ダウンロード
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="5" class="hidden-xs-only">
        <v-img :src="require('../assets/toyama.png')" contain height="300"></v-img>
      </v-col>
    </v-row>
    <div id="privacy" />
  </v-container>
</template>

<script>
export default {
  name: 'Title',
}
</script>

<style scoped>
.title-back {
  background-color: #52ab91;
}

.margin-top {
  margin-top: 30px;
}
</style>
